import { createContext } from 'react';

import { SelectedGroupGlcPermissionContextProps } from './SelectedGroupGlcPermissionContext.types';

export const SelectedGroupGlcPermissionContext = createContext<SelectedGroupGlcPermissionContextProps | undefined>(
  undefined,
);
